export interface TimelineItemHandleProps {
  id: string;
  className?: string;
  type?: TimelineItemHandleType;
  side?: TimelineHandleSide;
  activeType?: TimelineItemHandleType;
  isActive?: boolean;
}

export enum TimelineHandleSide {
  Left = 'left',
  Right = 'right',
}
export enum TimelineItemHandleType {
  Default = 'default',
  Blue = 'blue',
  Purple = 'purple',
  Green = 'green',
}
